import React from 'react';

import Framework from "@beardeddevops/react.framework";
import UserRoles from "constants/UserRoles";
import {Collections} from "../../../../../components";

const breadcrumbsStatic = [{
	name: 'Dispatch',
	url: '/dispatch',
	icon: 'dashboard',
}];

export default class RecentlyBooked extends Framework.Components.View {

	access = [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk];

	render() {
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: "Booked",
				url: `/dispatch/booked`,
				icon: 'book',
			}
		]);

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}/>
				<Collections.RecentlyBooked
					history={this.props.history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					showCSV={this.props.roles.includes(UserRoles.Admin)}
				/>
			</div>
		);
	}
}


